import React, { useState } from 'react';

const SamplesCLIInstructions: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const commands = [
    {
      label: 'Upload a notebook',
      command: [
        'docker compose exec infra-tools aws s3 cp my-notebook.ipynb \\',
        '  s3://propalgos-data-us-east-2/samples/getting-started/ \\',
        '  --profile propalgos-production --region us-east-2',
      ].join('\n'),
    },
    {
      label: 'Upload a directory',
      command: [
        'docker compose exec infra-tools aws s3 sync ./notebooks/ \\',
        '  s3://propalgos-data-us-east-2/samples/ \\',
        '  --profile propalgos-production --region us-east-2 \\',
        '  --exclude ".*" --exclude "__pycache__/*"',
      ].join('\n'),
    },
    {
      label: 'List current samples',
      command: [
        'docker compose exec infra-tools aws s3 ls \\',
        '  s3://propalgos-data-us-east-2/samples/ \\',
        '  --recursive --profile propalgos-production --region us-east-2',
      ].join('\n'),
    },
    {
      label: 'Trigger GCS replication',
      command: [
        'curl -X POST http://localhost:8000/api/v1/admin/samples/replicate \\',
        '  -H "Authorization: Bearer $TOKEN"',
      ].join('\n'),
    },
  ];

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <div className="bg-gray-900 border border-gray-800 rounded-lg overflow-hidden">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-gray-800/50 transition-colors"
      >
        <div className="flex items-center gap-2">
          <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <span className="text-sm font-medium text-gray-300">CLI Upload Instructions</span>
        </div>
        <svg
          className={`w-4 h-4 text-gray-500 transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isExpanded && (
        <div className="pb-4 space-y-4 border-t border-gray-800">
          <p className="text-xs text-gray-500 mt-3 px-4">
            Bulk uploads are faster via CLI. Tags are auto-applied by bucket policy.
            Files appear on AWS instances immediately (FUSE mount); GCP instances require replication.
          </p>

          {commands.map((cmd, i) => (
            <div key={i} className="px-4">
              <div className="flex items-center justify-between mb-1">
                <span className="text-xs font-medium text-gray-400">{cmd.label}</span>
                <button
                  onClick={() => copyToClipboard(cmd.command)}
                  className="text-xs text-gray-500 hover:text-gray-300 transition-colors"
                >
                  Copy
                </button>
              </div>
              <pre className="bg-gray-950 text-gray-300 font-mono text-xs p-3 rounded-lg overflow-x-auto whitespace-pre text-left">{cmd.command}</pre>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SamplesCLIInstructions;
